var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled from 'styled-components';
import { node } from 'prop-types';
import Box from '../../../Box';
var Actions = styled(Box).attrs({
  as: 'footer'
})(_templateObject || (_templateObject = _taggedTemplateLiteralLoose([""])));
Actions.propTypes = {
  children: node.isRequired
};
Actions.displayName = 'Card.Actions';
export default Actions;